import React from 'react';
import {
    Box,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip
} from '@mui/material';

const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
        case 'delivered':
        case 'open':
            return 'success';
        case 'failed':
        case 'invalid_email':
            return 'error';
        case 'pending':
        case 'processed':
            return 'warning';
        default:
            return 'default';
    }
};

const getStatusLabel = (status) => {
    switch (status?.toLowerCase()) {
        case 'delivered':
            return 'Delivered';
        case 'open':
            return 'Opened';
        case 'failed':
            return 'Failed';
        case 'invalid_email':
            return 'Invalid Email';
        case 'pending':
            return 'Pending';
        case 'processed':
            return 'Sent';
        default:
            return status || 'Unknown';
    }
};

const EmailHistory = ({ emailHistory }) => {
    if (!emailHistory?.length) {
        return (
            <Paper sx={{ p: 2, mb: 2 }}>
                <Typography variant="h6" gutterBottom>Email History</Typography>
                <Typography color="textSecondary">No email history available</Typography>
            </Paper>
        );
    }

    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Typography variant="h6" gutterBottom>Email History</Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Template</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Event Type</TableCell>
                            <TableCell>Message ID</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {emailHistory.map((email, index) => (
                            <TableRow key={`${email.message_id}-${index}`}>
                                <TableCell>
                                    {new Date(email.created_at).toLocaleString()}
                                </TableCell>
                                <TableCell>
                                    {email.email_template || 'N/A'}
                                </TableCell>
                                <TableCell>
                                    <Chip
                                        label={getStatusLabel(email.status)}
                                        color={getStatusColor(email.status)}
                                        size="small"
                                    />
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">
                                        {email.event_type}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="caption" color="textSecondary">
                                        {email.message_id}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default EmailHistory;
